<div *ngIf="form" class="box">
  <div class="row mx-0 d-flex align-items-start justify-content-center mt-2" style="min-height: 40px">
    <bdg-label class="col-8" type="body-1">{{ title }}</bdg-label>

    <div class="col-4 d-flex justify-content-end">
      <mat-radio-group [formControl]="form.controls.arquivoValido" *ngIf="!viewAsCoordenador; else elseTag">
        <mat-radio-button [value]="true" data-testid="radio-valido"> Válido </mat-radio-button>
        <mat-radio-button class="ml-2" [value]="false" data-testid="radio-invalido"> Inválido </mat-radio-button>
      </mat-radio-group>
      <ng-template #elseTag>
        <bdg-tag class="mr-n2" *ngIf="isArquivoValido" accent="teal" icon="check_circle">Válido</bdg-tag>
        <bdg-tag class="mr-n2" *ngIf="isArquivoInvalido" accent="red" icon="error">Inválido</bdg-tag>
      </ng-template>
    </div>
  </div>

  <div class="row mx-0 d-flex align-items-center justify-content-center" style="min-height: 40px">
    <div class="col-6 d-flex">
      <a *ngIf="filename" href="javascript:void(0)" (click)="download()">
        <div class="d-flex align-items-center" [matTooltip]="filename">
          <div class="d-inline-block text-truncate" style="max-width: 208px">
            {{ filename }}
          </div>
          <mat-icon style="color: black" *ngIf="filename">get_app</mat-icon>
        </div>
      </a>
    </div>

    <div class="col-6 d-flex justify-content-end">
      <mat-error class="mat-caption d-inline" *ngIf="arquivoValidoControlError">
        <div class="d-flex align-items-center">
          {{ arquivoValidoControlError }}
          <mat-icon class="ml-2" *ngIf="arquivoValidoControlError">error</mat-icon>
        </div>
      </mat-error>
    </div>
  </div>

  <div *ngIf="isArquivoInvalido" class="row mx-0 w-100 justify-content-between align-items-center mt-2">
    <div class="col-12">
      <bdg-text-area-field
        [control]="form.controls.arquivoParecer"
        label="Parecer do documento"
        style="height: 130px"
        maxLength="500"
        data-testid="text-parecer-doc"
      ></bdg-text-area-field>
    </div>
  </div>
</div>
